export default [{
	path: '/orderUrl',
	name: 'orderUrl',
	meta: {
		title: "支付宝付款链接",
	},
	component: () => import('@/views/orderUrl')
}]
